import React, { Suspense, useEffect, useState } from 'react'
import { renderRoutes } from 'react-router-config'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/styles'
import { LinearProgress } from '@material-ui/core'

import { NavBar, TopBar } from './components'
import { useDispatch, useSelector } from 'react-redux'
import { getAccount, logout } from 'redux/actions'
import checkToken from 'utils/checkToken'
import appApiUrl from 'utils/apiUrl'
import { useSnackbar } from 'notistack'

const useStyles = makeStyles(() => ({
  root: {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden'
  },
  topBar: {
    zIndex: 2,
    position: 'relative'
  },
  container: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden'
  },
  content: {
    overflowY: 'auto',
    flex: '1 1 auto',
    position: 'relative'
  }
}))

const Dashboard = props => {
  const { enqueueSnackbar } = useSnackbar()
  const { route } = props
  const classes = useStyles()
  const dispatch = useDispatch()
  const userId = useSelector(state => state.session?.userId)
  const token = useSelector(state => state.session?.token)
  const userType = useSelector(state => state.session?.userType)
  const updateAccountTrigger = useSelector(
    state => state.unsaved?.updateAccountTrigger
  )
  const [openNavBarMobile, setOpenNavBarMobile] = useState(false)
  const handleNavBarMobileOpen = () => {
    setOpenNavBarMobile(true)
  }
  const handleNavBarMobileClose = () => {
    setOpenNavBarMobile(false)
  }
  useEffect(() => {
    const controller = new AbortController()
    const signal = controller.signal
    var myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Authorization', `Bearer ${token}`)
    var raw = JSON.stringify({
      userId,
      userType
    })

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
      signal
    }

    fetch(`${appApiUrl}account/getAccount.php`, requestOptions)
      .then(response => response.json())
      .then(result => {
        checkToken(result, dispatch)
        if (result?.account?.length === 0) dispatch(logout())
        if (result.is_success) {
          dispatch(
            getAccount({
              ...result.account?.[0],
              phone:
                result?.account?.[0]?.companyPhone ||
                result?.account?.[0]?.phone
            })
          )
        }
      })
      .catch(error => {
        if (error.name === 'AbortError') return
        enqueueSnackbar(error.message, {
          variant: 'error'
        })
      })
    return () => controller.abort()
    // eslint-disable-next-line
  }, [userId, userType, updateAccountTrigger])
  return (
    <div className={classes.root}>
      <TopBar
        className={classes.topBar}
        onOpenNavBarMobile={handleNavBarMobileOpen}
      />
      <div className={classes.container}>
        <NavBar
          onMobileClose={handleNavBarMobileClose}
          openMobile={openNavBarMobile}
        />
        <main id="main" className={classes.content}>
          <Suspense fallback={<LinearProgress />}>
            {renderRoutes(route.routes)}
          </Suspense>
        </main>
      </div>
    </div>
  )
}

Dashboard.propTypes = {
  route: PropTypes.object
}

export default Dashboard
